module.exports = __webpack_public_path__ + "static/media/dayDateHighlight.9d54d1c8.svg";